module.exports = __webpack_public_path__ + "media/images/weploy_logo_black-fb0ea10c.png";